// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mobile-heading[data-v-1e30a322]{text-align:center;margin:0 0 8px}@media(min-width:768px){.mobile-heading[data-v-1e30a322]{display:none}}.sale-block_rubik .mobile-heading[data-v-1e30a322]{font-family:Rubik,\"FuturaPT\",Arial,sans-serif}.sale-block_futura-pt:not(.sale-block_rubik) .mobile-heading[data-v-1e30a322]{font-family:\"FuturaPT\",Arial,sans-serif}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
